const recommendedPolicyGroupsData = [
  {
    name: 'Vanguard Ring',
    description: '',
  },
  {
    name: 'Early Adoption Ring',
    description: '',
  },
  {
    name: 'General Adoption Ring',
    description: '',
  },
  {
    name: 'Late Adoption Ring',
    description: '',
  },
];

export default recommendedPolicyGroupsData;
